import { FaAngleLeft, FaAngleRight, FaAngleDoubleLeft, FaAngleDoubleRight } from "react-icons/fa";

interface CustomPaginationProps {
  currentPage: number;
  perPage: number;
  totalRows: number;
  onPageChange: (page: number) => void;
  onRowsPerPageChange: (size: number) => void;
}

const CustomPagination = ({
  currentPage,
  perPage,
  totalRows,
  onPageChange,
  onRowsPerPageChange,
}: CustomPaginationProps) => {
  const totalPages = Math.ceil(totalRows / perPage);

  // Guards to prevent invalid calls
  const goToPage = (page: number) => {
    if (page < 1 || page > totalPages) return;
    onPageChange(page);
  };

  return (
    <div className="d-flex flex-wrap justify-content-end align-items-center mt-3 gap-2">
      <div className="d-flex align-items-center">
        <span className="me-2 fw-semibold">Rows per page:</span>
        <select
          className="form-select form-select-sm"
          style={{ width: "auto" }}
          value={perPage}
          onChange={(e) => onRowsPerPageChange(Number(e.target.value))}
        >
          {[10, 25, 50, 100].map((size) => (
            <option key={size} value={size}>
              {size}
            </option>
          ))}
        </select>
      </div>

      <div className="ms-3">
        <span className="fw-semibold">
         Showing  {(currentPage - 1) * perPage + 1} -{" "}
          {Math.min(currentPage * perPage, totalRows)} of {totalRows} entries
        </span>
      </div>

      <div className="d-flex align-items-center ms-3">
        <button
          className="btn btn-outline-secondary btn-sm mx-1"
          onClick={() => goToPage(1)}
          disabled={currentPage === 1}
          title="First Page"
        >
          <FaAngleDoubleLeft />
        </button>

        <button
          className="btn btn-outline-secondary btn-sm mx-1"
          onClick={() => goToPage(currentPage - 1)}
          disabled={currentPage === 1}
          title="Previous Page"
        >
          <FaAngleLeft />
        </button>

        <button
          className="btn btn-outline-secondary btn-sm mx-1"
          onClick={() => goToPage(currentPage + 1)}
          disabled={currentPage >= totalPages}
          title="Next Page"
        >
          <FaAngleRight />
        </button>

        <button
          className="btn btn-outline-secondary btn-sm mx-1"
          onClick={() => goToPage(totalPages)}
          disabled={currentPage >= totalPages}
          title="Last Page"
        >
          <FaAngleDoubleRight />
        </button>
      </div>
    </div>
  );
};

export default CustomPagination;
